import { getTabDevicesName } from '../../../hooks/useFirebaseSessionLogic/useTabDeviceId/tabUuid-helper';
import customConfirmAlert from '../../ConfirmAlert';
import styles from './index.module.scss';

function duplicateRTMSessionConfirmAlert(devices: { [key: string]: number }) {
  customConfirmAlert({
    title: 'OneStep is open in another window or device',
    body: `You have active RTM tracking in another session: [${getTabDevicesName(
      devices
    )}].`,
    subText: [
      'To continue RTM tracking here, please close the other session(s). This ensures accurate RTM time tracking and prevents duplication.',
      'If you believe this is an error, please check your devices and close any active sessions.',
    ],
    label: 'Close',
    hideCancel: true,
    classes: {
      overlay: styles.overlay,
      body: styles.body,
      primary: styles.btn,
      closeBtn: styles.closeBtn,
    },
  });
}

export default duplicateRTMSessionConfirmAlert;
